import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  AfterViewInit,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Animations
// Common
import {
  ErrorParseService,
  PermissionsService,
  IFormConfiguration,
  LGEDataService,
} from '../../commons';
// import { AngularMaterialService, ErrorParseService, ICharityForms } from '../commons';
// State
import { Store } from '@ngrx/store';
import { Observable, of, Subscription } from 'rxjs';
import * as fromCharityForms from './state/charity-forms.selectors';
import * as fromAuthentication from '../login/state/login.selectors';
import * as CharityFormsAction from './state/charity-forms.actions';
import * as lgeApp from '../../app/state/app.actions';

import { ActivatedRoute, Router } from '@angular/router';
import { catchError, map, skipWhile, tap } from 'rxjs/operators';
import { slideInDownAnimation } from 'src/app/app.animation';
import { FormCCService } from 'src/commons/services/formCC.service';
import { AngularMaterialService } from 'src/commons/utilities/angular.material.service';
import { IFormConfig } from 'src/commons/interfaces/user.interface';
import * as _ from 'lodash';
import { from } from 'rxjs';

@Component({
  selector: 'charity-forms-screen',
  templateUrl: 'charity-forms.component.html',
  styleUrls: ['charity-forms.component.scss'],
  animations: [slideInDownAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CharityFormsScreenComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Input() private pending$: Observable<boolean>;
  private pendingSubscription: Subscription;
  private pending: boolean;
  @Input() private error$: Observable<string | null>;
  private errorSubscription: Subscription;
  private error: string | null;
  @Input() private formConfigs$: Observable<IFormConfiguration[] | null>;
  private formConfigsSubscription: Subscription;
  // private stateData: ICharityForms | null;
  formPPConfig: IFormConfig;
  formFOConfig: IFormConfig;
  formCIConfig: IFormConfig;
  formCGConfig: IFormConfig;
  formESConfig: IFormConfig;
  ein;
  isTest = 'TEAM';
  formConfigList = [];
  showErrorMessage: string;
  isFormPPExpired = false;
  isFormFOExpired = false;
  isFormCIExpired = false;
  isFormCGExpired = false;
  isFormESExpired = false;
  isInternal = false;

  constructor(
    private store: Store<fromCharityForms.State>,
    private storeAuth: Store<fromAuthentication.State>,
    private ref: ChangeDetectorRef,
    private fb: FormBuilder,
    private ams: AngularMaterialService,
    private errorParse: ErrorParseService,
    private route: ActivatedRoute,
    private router: Router,
    private formCCService: FormCCService,
    private _dataService: LGEDataService,
    private permissionsService: PermissionsService
  ) {
    this.selectState();
    this.createForms();
    this.isInternal = this.permissionsService.isInternal();
    this.ref.markForCheck();
  }

  ngOnInit() {
    if (this.isInternal) {
      if (
        this.hasRole('ADMIN') ||
        this.hasRole('CITAPPROVER') ||
        this.hasRole('FOUNDATIONAPPROVER') ||
        this.hasRole('PFTPAPPROVER')
      ) {
        this.isFormCIExpired = true;
        this.isFormPPExpired = true;
        this.isFormFOExpired = true;
        this.isFormCGExpired = true;
        this.isFormESExpired = true;
      } else {
        this.isFormCIExpired = false;
        this.isFormPPExpired = false;
        this.isFormFOExpired = false;
        this.isFormCGExpired = false;
        this.isFormESExpired = false;
      }
    } else {
      this.ams.showLoader('Loading...');
      this.GetActiveForm();
    }
  }

  ngAfterViewInit(): void {
    this.startSubscriptions();
  }
  // private GetFormConfigs() {
  //     // this.isLoadingResults = true;
  //     this._dataService.GetFormConfigs()
  //         .then(data => {
  //             // console.log(data);
  //             // this.emailTemplateList = data;
  //             this.ams.closeDialog();
  //             // console.log('formConfig list: ', data);
  //             // this.formConfigList = data;
  //             this.formPPConfig = data.find((item) => item.name === 'PP');
  //             this.formFOConfig = data.find((item) => item.name === 'FO');
  //             this.formCIConfig = data.find((item) => item.name === 'CI');
  //             this.formCGConfig = data.find((item) => item.name === 'CG');
  //             // this.formConfig.reset();
  //             // this.formConfigList = new MatTableDataSource(data);
  //             // this.sortFilterPaginate();
  //             this.ref.markForCheck();
  //         }, (error:Error) => {
  //             // console.log(error);
  //             this.ams.closeDialog();
  //             this.showErrorMessage = 'Resource not available!';
  //             this.ams.showAlert('Error!', 'Resource not available!');
  //             this.ref.markForCheck();
  //         });
  //     this.ref.markForCheck();
  // }
  onCharityCheck() {
    this.ams.showCharityCheck('EIN Verification', '');
    this.ams.charityCheck.afterClosed().subscribe((result) => {
      if (result && result.ein) {
        // console.log('proxypool:APPID');
        // console.log('EIN: ', result.ein);
        this.ams.showLoader('Verifying...');
        this.ref.markForCheck();
        this._dataService.CharityCheck(result.ein).subscribe({
          next: (data) => {
            if (data) {
              if (typeof data === 'string' && data === 'invalid') {
                this.ams.closeDialog();
                this.ams.showAlert(
                  'Invalid!',
                  'EIN: ' +
                    result.ein +
                    ' is not valid !' +
                    ' Please contact contributions@lge-ku.com'
                );
              } else {
                this.ams.closeDialog();
                // let result = JSON.parse(data);
                // // console.log(result.data);

                let orgInfoData: any = {};
                orgInfoData.orgInfoId = null;
                orgInfoData.webAddress = '';
                orgInfoData.payToOption = 'no';
                orgInfoData.payTo = '';
                orgInfoData.EIN = data.ein;
                orgInfoData.name = data.organization_name.toUpperCase();
                orgInfoData.address1 = data.address_line1;
                orgInfoData.address2 = data.address_line2;
                orgInfoData.city = data.city;
                orgInfoData.state = data.state;
                orgInfoData.zipCode = data.zip;
                orgInfoData.isInternal = data.isInternal;
                orgInfoData.subsection_501 = data.subsection_501;
                // console.log('orgInfoData');
                // console.log(orgInfoData);
                this.formCCService.setOrgInfoDetails(orgInfoData);

                this.router.navigate(['charitable-contribution'], {
                  relativeTo: this.route,
                });
              }
            }
          },
          error: (error) => {
            // console.log(error);
            this.ams.closeDialog();
            this.ams.showAlert(
              'Error!',
              `Please try again later! \n Details:${JSON.stringify(error)}`
            );
            // let ein = result.replace(2,'');
            // this.ams.showAlert('Invalid EIN!', ein + ' is not valid EIN!');
            this.ref.markForCheck();
          },
        });
      }
    });
  }

  onCharityCheckTestOnly() {
    let orgInfoData: any = {};
    orgInfoData.orgInfoId = null;
    orgInfoData.webAddress = '';
    orgInfoData.payToOption = 'no';
    orgInfoData.payTo = '';
    orgInfoData.EIN = '61-1257368';
    orgInfoData.name = 'LG&E AND KU (TEST ONLY)';
    orgInfoData.address1 = '220 W Main St';
    orgInfoData.address2 = '';
    orgInfoData.city = '"Louisville"';
    orgInfoData.state = 'KY';
    orgInfoData.zipCode = '40202';
    orgInfoData.isInternal = 'true';
    // console.log('orgInfoData');
    // console.log(orgInfoData);
    this.formCCService.setOrgInfoDetails(orgInfoData);

    this.router.navigate(['charitable-contribution'], {
      relativeTo: this.route,
    });
  }

  hasRole(role: string) {
    return this.permissionsService.hasRoles(role);
  }

  // private isInternal() {
  //     return this.permissionsService.isInternal();
  // }

  // Select state
  private selectState(): void {
    this.pending$ = this.store.select(
      fromCharityForms.getCharityFormsScreenPending
    );
    this.formConfigs$ = this.storeAuth
      .select(fromAuthentication.getFormConfigs)
      .pipe(skipWhile((configs) => configs === null || configs === undefined));
    this.error$ = this.store
      .select(fromCharityForms.getCharityFormsScreenError)
      .pipe(
        skipWhile(
          (error) => error === undefined || error === null || error === ''
        )
      );
  }

  private displayLoader(pending: boolean): void {
    if (pending) {
      setTimeout(() => {
        this.ams.showLoader('Loading...');
        this.ref.markForCheck();
      });
    } else {
      this.ams.closeDialog().then(() => {
        if (
          this.error !== null &&
          this.error !== undefined &&
          this.error !== ''
        ) {
          this.displayError(this.error);
        }
      });
    }
  }

  private displayError(error: any): void {
    let errorMessage;
    if (this.errorParse.foundKeyWord(error, 'CORPCOMMONWS')) {
      errorMessage = this.errorParse.translateCCError(error);
    } else {
      errorMessage = error instanceof Object ? error.message : error;
    }
    this.ams.showAlert('Loading Error', errorMessage);
    this.ams.alert.afterClosed().subscribe((result) => {
      this.store.dispatch(
        new CharityFormsAction.CharityFormsScreenErrorReset()
      );
    });
  }

  // Create reactive forms
  private createForms(): void {}
  // Opens sidenav if on mobile
  openSidenav(): void {
    this.store.dispatch(new lgeApp.OpenSidenav());
  }
  // Subscribe to state data and mark it for changes
  private startSubscriptions(): void {
    this.pendingSubscription = this.pending$.subscribe((data) => {
      this.pending = data;
      this.displayLoader(this.pending);
      this.ref.markForCheck();
    });
    this.errorSubscription = this.error$.subscribe((data) => {
      this.error = data;
      this.ref.markForCheck();
    });
    this.formConfigsSubscription = this.formConfigs$.subscribe((data) => {
      if (data !== null) {
        this.ams.closeDialog();
        this.ams.showLoader("Loading forms's accissibility ..");
        let configs = JSON.parse(JSON.stringify(data));
        this.formPPConfig = _.find(configs, (item) => item.name === 'PP');
        this.formFOConfig = _.find(configs, (item) => item.name === 'FO');
        this.formCIConfig = _.find(configs, (item) => item.name === 'CI');
        this.formCGConfig = _.find(configs, (item) => item.name === 'CG');
        this.formESConfig = _.find(configs, (item) => item.name === 'ES');
        setTimeout(() => {
          this.ams.closeDialog();
          this.ref.markForCheck();
        }, 1000);
      }
    });
  }

  // Unsubscribe from state data changes
  private endSubscriptions(): void {
    this.pendingSubscription.unsubscribe();
    this.errorSubscription.unsubscribe();
    this.formConfigsSubscription.unsubscribe();
  }

  ngOnDestroy() {
    this.endSubscriptions();
  }

  //Mayur

  cc() {
    this.router.navigate(['charitable-contribution'], {
      relativeTo: this.route,
    });
  }

  ci() {
    this.router.navigate(['community-investment'], { relativeTo: this.route });
  }

  foundation() {
    this.router.navigate(['foundation'], { relativeTo: this.route });
  }

  pftp() {
    this.router.navigate(['plant-planet'], { relativeTo: this.route });
  }

  isFormOpen(name: string) {
    return this.formConfigList.find((item) => item === name) !== undefined;
  }

  GetActiveForm() {
    this._dataService.GetActiveForm().subscribe({
      next: (data) => {
        // console.log(data);
        // this.emailTemplateList = data;
        // console.log('formConfig list: ', data);
        this.formConfigList = data;
        // this.formConfigList = new MatTableDataSource(data);
        // this.sortFilterPaginate();
        this.isFormPPExpired = this.isFormOpen('PP');
        this.isFormFOExpired = this.isFormOpen('FO');
        this.isFormCIExpired = this.isFormOpen('CI');
        this.isFormCGExpired = this.isFormOpen('CG');
        this.isFormESExpired = this.isFormOpen('ES');
        this.ams.closeDialog();
        this.ref.markForCheck();
      },
      error: (error: Error) => {
        // console.log(error);
        this.ams.closeDialog();
        this.showErrorMessage = 'Resource not available!';
        this.ams.showAlert('Error!', 'Resource not available!');
        this.ref.markForCheck();
      },
    });
  }
}
